import { Injectable } from '@angular/core';
import { Observable, BehaviorSubject, throwError } from 'rxjs';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { tap, map, catchError } from 'rxjs/operators';
import { ContactPersonDesignationFilterModel, ParentStationMasterFilterModel, StationMasterFilterModel } from './station-master';
import { Result } from 'app/main/shared/result';
import { environment } from 'environments/environment';

@Injectable({
  providedIn: 'root'
})
export class StationGridService  {

    httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json; charset=utf-8'
        })
      };

  constructor(private http: HttpClient) {
  }

  public GetStationMaster(data:StationMasterFilterModel) {

    return this.http.post<Result>(environment.apiUrl +`/Route/GetStationMaster`,data, this.httpOptions);
  }

  public GetParentStation(data:ParentStationMasterFilterModel) {

    return this.http.post<Result>(environment.apiUrl +`/Route/GetParentStation`,data, this.httpOptions);
  }

  public GetStationType() {

    return this.http.post<Result>(environment.apiUrl +`/Route/GetStationType`,null, this.httpOptions);
  }

  public GetRegionalLanguageMaster() {

    return this.http.post<Result>(environment.apiUrl +`/Common/GetRegionalLanguageMaster`,null, this.httpOptions);
  }

  public GetDesignationMaster(data:ContactPersonDesignationFilterModel) {

    return this.http.post<Result>(environment.OPRSAPIUrl +`/Designation/GetDesignationMaster`,data, this.httpOptions);
  }

  public GetGeoStructure(data:any) {

    return this.http.post<Result>(environment.apiUrl +`/GeoHierarchyandOrganization/GetGeoStructure`,data, this.httpOptions);

  }
  public InsertImportStationMaster(data: any) {
    return this.http.post<Result>(environment.apiUrl + `/Route/ImportInsertStationMaster`, data, this.httpOptions);
  }
   public InsertandUpdateStationMaster(data: any) {
    return this.http.post<Result>(environment.apiUrl + `/Route/InsertandUpdateStationMaster`, data, this.httpOptions);
  }

  public GetStationMasterGrid(data: any) {
    return this.http.post<Result>(environment.apiUrl + `/Route/GetStationMasterGrid`, data, this.httpOptions);
  }

  public GetLocationDetail(ApiKey:any,SearchText:any) {
    return this.http.get<Result>(`${environment.apiUrl}/Route/GetFetchLocationData?APIKey=` + ApiKey + `&queryText=` + SearchText);
  }

  public GetAllStationPoints(data: any) {
    return this.http.post<Result>(environment.apiUrl + `/Route/GetAllStationPoints`, data, this.httpOptions);
  }

  public  DownloadFile(data:any) {    
    const headers = new HttpHeaders()
    .set('Accept', 'application/xlsx; charset=utf-8');
    return   this.http.post(environment.apiUrl + `/Route/DownloadMasterFile`, data,
    { headers, observe: 'response', responseType: 'blob' }
    );
  }

}

